import CopyFormUrlDialog from './CopyFormUrlDialog.view';

export default CopyFormUrlDialog;
